<template>
  <div>
    <custom-modal :title="'Doładowanie bonusowe'" :id="'addToWalletPromotion'">
      <template #content>
        <div class="modal-body">
          <p class="info-label mb-4">
            <span class="bold">
              Dodając doładowanie bonusowe wystawisz notę księgową.
            </span>
            <span>
              Jeżeli potrzebujesz ją skorygować skontaktuj się z lekarzem lub
              farmaceutą.
            </span>
          </p>

          <div v-if="stepNumber === 1">
            <p class="standard-label mb-0">Co zrobić?</p>
            <div class="question-radios">
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="newDescription"
                  id="newDescription"
                  v-model="newDescription"
                  :value="true"
                />
                <label class="form-check-label" for="newDescription">
                  Dodaj własny opis
                </label>
              </div>
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="newDescription"
                  id="oldDescription"
                  v-model="newDescription"
                  :value="false"
                />
                <label class="form-check-label" for="oldDescription"
                  >Wybierz istniejący opis</label
                >
              </div>
            </div>
            <div class="own-description" v-if="newDescription">
              <p class="standard-label">Dodaj opis</p>
              <textarea
                name="own-description-textarea"
                id="own-description-textarea"
                maxlength="100"
                placeholder="Uzupełnij opis"
                v-model="selectedDescription"
              >
              </textarea>
              <div class="own-description-counter">
                {{ selectedDescription.length }} / 100
              </div>
            </div>
            <div class="own-description" v-else>
              <p class="standard-label">Dodaj opis</p>
              <div class="descriptions">
                <div
                  class="radio-box ml-2"
                  v-for="description in descriptions"
                  :key="description.id"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="selectedDescription"
                    :id="description.id"
                    :value="description.description"
                    v-model="selectedDescription"
                  />
                  <label class="form-check-label" :for="description.id">
                    <div class="description">
                      <div
                        class="description-name"
                        :class="
                          selectedDescription === description.description
                            ? 'font-weight-bold'
                            : ''
                        "
                      >
                        {{ description.name }}
                      </div>

                      <div class="ml-4 description-description">
                        "{{ description.description }}"
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <p class="standard-label mt-4">Kwota</p>
            <input
              type="number"
              step="0.01"
              class="form-control"
              v-model="amountToAdd"
              placeholder="Podaj kwotę"
            />

            <div class="buttons">
              <custom-button
                :gray="true"
                title="Anuluj"
                :size="'small'"
                @click="closeBonusTopUpModal()"
                :customStyles="'text-transform: uppercase; width: 290px; height: 30px;'"
              />
              <custom-button
                :gradient="true"
                title="Dalej"
                :size="'small'"
                @click="moveToStepTwo"
                :customStyles="'text-transform: uppercase;width: 290px; height: 30px;'"
              />
            </div>
          </div>

          <div v-if="stepNumber === 2">
            <p class="standard-label mb-0">Wybierz dział w fakturownii</p>
            <div class="descriptions">
              <div
                class="radio-box ml-2"
                v-for="department in departments"
                :key="department.id"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="selectedDepartment"
                  :id="department.id"
                  :value="department.id"
                  v-model="selectedDepartmentId"
                />
                <label class="form-check-label" :for="department.id">
                  <div class="description">
                    <div
                      class="department-name"
                      :class="
                        selectedDepartmentId === department.id
                          ? 'font-weight-bold'
                          : ''
                      "
                    >
                      {{ department.name }}
                    </div>

                    <div class="ml-4 department-description">
                      "{{ selectedDescription }}"
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div class="buttons">
              <custom-button
                :gray="true"
                title="Wstecz"
                :size="'small'"
                @click="moveToStepOne"
                :customStyles="'text-transform: uppercase; width: 290px; height: 30px;'"
              />
              <custom-button
                :disabled="loading"
                :gradient="true"
                title="Wystaw"
                :size="'small'"
                @click="handleTopUp()"
                :customStyles="'text-transform: uppercase;width: 290px; height: 30px;'"
              />
            </div>
          </div>
        </div>
        <large-amount-confirm
          :visible="largeAmountConfirmVisible"
          :amount="amountToAdd"
          @confirmed="confirmLargeAmount"
          @cancel="largeAmountConfirmVisible = false"
        />
      </template>
    </custom-modal>
    <button
      style="visibility: hidden"
      id="addToWalletPromotion-open"
      type="button"
      data-toggle="modal"
      data-target="#addToWalletPromotion"
    />
  </div>
</template>

<script>
import axios from "../axios";
import CustomButton from "./CustomButton.vue";
import CustomModal from "./CustomModal.vue";
import LargeAmountConfirm from "./LargeAmountConfirm.vue";
import { requiresAmountConfirmation } from "../utils/largeAmount";
export default {
  components: { CustomModal, CustomButton, LargeAmountConfirm },
  emits: ["top-up-done"],
  name: "TopUpModal",
  data() {
    return {
      amountToAdd: null,
      loading: false,
      newDescription: true,
      descriptions: [],
      departments: [],
      selectedDescription: "",
      selectedDepartmentId: null,
      stepNumber: 1,
      largeAmountConfirmVisible: false,
    };
  },
  async mounted() {
    const descriptionsResponse = await axios.get(
      `/api/accountingNoteDescriptions`
    );
    const departmentsResponse = await axios.get(
      `/api/payment/fakturowniaDepartments`
    );

    this.descriptions = descriptionsResponse.data;
    this.departments = departmentsResponse.data;
  },
  methods: {
    moveToStepOne() {
      this.stepNumber = 1;
    },
    moveToStepTwo() {
      if (!this.validateSelectedDescriptionAndAmount()) {
        return;
      }
      this.stepNumber = 2;
    },
    closeBonusTopUpModal() {
      this.newDescription = true;
      this.selectedDescription = "";
      this.amountToAdd = null;
      this.stepNumber = 1;
      this.selectedDepartmentId = null;
      this.largeAmountConfirmVisible = false;

      document.getElementById("addToWalletPromotion-close").click();
    },

    validateSelectedDescriptionAndAmount() {
      if (!this.selectedDescription) {
        this.$notify({
          group: "error",
          text: "Wymagane jest wybranie opisu z listy lub dodanie własnego",
        });
        return false;
      }
      if (!this.amountToAdd) {
        this.$notify({
          group: "error",
          text: "Podaj kwotę doładowania bonusowego",
        });
        return false;
      }
      return true;
    },

    validateSelectedDepartment() {
      if (!this.selectedDepartmentId) {
        this.$notify({
          group: "error",
          text: "Wymagane jest wybranie działu w fakturownii",
        });
        return false;
      }
      return true;
    },

    handleTopUp() {
      if (!this.validateSelectedDescriptionAndAmount()) {
        return;
      }
      if (!this.validateSelectedDepartment()) {
        return;
      }
      if (requiresAmountConfirmation(this.amountToAdd)) {
        this.largeAmountConfirmVisible = true;
        return;
      }
      this.submitTopUp();
    },

    confirmLargeAmount() {
      this.largeAmountConfirmVisible = false;
      this.submitTopUp();
    },

    async submitTopUp() {
      try {
        this.loading = true;
        const url = `/api/payment/wallet/income`;
        const data = {
          amount: this.amountToAdd,
          withoutAccountingNote: false,
          phoneNumber: this.$route.query.search,
          departmentId: this.selectedDepartmentId,
          noteDescription: this.selectedDescription,
          departmentName: this.departments.find(
            (department) => department.id === this.selectedDepartmentId
          ).name,
        };
        const response = await axios.post(url, data);
        if (response.status === 200) {
          this.$notify({
            group: "success",
            text: "Pomyślnie dodano kwotę do portfela użytkownika",
          });
          this.$emit("top-up-done");
          this.selectedDepartmentId = null;
          this.selectedDescription = "";
          this.amountToAdd = null;
          this.stepNumber = 1;
          this.newDescription = true;

          this.closeBonusTopUpModal();

          setTimeout(() => {
            this.loading = false;
          }, 2000);
        }
      } catch (error) {
        console.log(error);
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  font-size: 14px;
  padding: 10px;
}
div {
  padding: 0;
}
.info-label {
  font-size: 18px;
  font-style: normal;
  line-height: 30px;
}
.bold {
  font-weight: 600;
}
.standard-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 30px;
}
.question-radios {
  display: flex;
  gap: 4rem;
  margin-left: 1.25rem;
}
.descriptions {
  margin-left: 1rem;
}
.radio-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;
}
.form-check-label {
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
}
input[type="radio"] {
  accent-color: #e2037e;
}
.own-description {
  margin-top: 1rem;
}
.own-description textarea {
  width: 100%;
  padding: 10px;
  font-size: 14px;
}
input {
  font-size: 14px;
}
.description {
  display: flex;
  align-items: center;
}
.description-name {
  width: 255px;
  max-width: 255px;
  min-width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.description-description {
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 3rem;
}

.department-name {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.department-description {
  width: 65%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.own-description-counter {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 13.479px;
  color: var(--granatowy-25, rgba(9, 7, 65, 0.25));
  text-align: right;
}
</style>